"use client";

import { createContext, useContext, type ReactNode } from "react";

const DealOfferPriceAlertContext = createContext<(() => void) | null>(null);

/**
 * Supplies the hero offer panel's "Notify me when it drops" action (the add-to-lists wishlist
 * flow) without threading it through every offer state component. Absent provider = no button.
 */
export function DealOfferPriceAlertProvider({
  children,
  onPriceAlert,
}: {
  children: ReactNode;
  onPriceAlert: (() => void) | null;
}) {
  return (
    <DealOfferPriceAlertContext.Provider value={onPriceAlert}>
      {children}
    </DealOfferPriceAlertContext.Provider>
  );
}

export function useDealOfferPriceAlert() {
  return useContext(DealOfferPriceAlertContext);
}
